export const VISIBILITY_DURATION = 3.5;
export const TRANSITION_DURATION = 250; // ms

// max number of visible messages
export const MAX_COUNT = 4;
